import { useCallback, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import Form from "../../../components/Form/Form";
import FormTitle from "../../../components/FormTitle/FormTitle";
import Input from "../../../components/Input/Input";
import { useUserStore } from "../../../contexts/userStore";
import AntiPassbackService from "../../../services/AntiPassbackService";
import "./FormAntiPassbacks.css";
import ToggleButton from "../../../components/ToggleButton/ToggleButton";
import { LuRouteOff } from "react-icons/lu";
import DualListAntiPassbacksAccessPoints from "../../../components/DualList/DualListAntiPassbacksAccessPoints/DualListAntiPassbacksAccessPoints";
import Checkbox from "../../../components/Checkbox/Checkbox";
import DualListGroups from "../../../components/DualList/DualListGroups/DualListGroups";
import { AntiPassbackAccessModulesDDL } from "../../../components/AntiPassbackAccessModulesDDL/AntiPassbackAccessModulesDDL";
import { AccessGroupsDDL } from "../../../components/AccessGroupsDDL/AccessGroupsDDL";

function FormAntiPassbacks(props) {
	const [name, setName] = useState(props.antiPassback?.name);
	const [enabled, setEnabled] = useState(props.antiPassback?.enabled ?? false);
	const [description, setDescription] = useState(
		props.antiPassback?.description
	);
	const [startTime, setStartTime] = useState(props.antiPassback?.startTime);
	const [endTime, setEndTime] = useState(props.antiPassback?.endTime);
	const [sunday, setSundayEnabled] = useState(
		props.antiPassback?.daysOfWeekActivated[0] || false
	);
	const [mondayEnabled, setMondayEnabled] = useState(
		props.antiPassback?.daysOfWeekActivated[1] || false
	);
	const [tuesdayEnabled, setTuesdayEnabled] = useState(
		props.antiPassback?.daysOfWeekActivated[2] || false
	);
	const [wednesdayEnabled, setWednesdayEnabled] = useState(
		props.antiPassback?.daysOfWeekActivated[3] || false
	);
	const [thursdayEnabled, setThursdayEnabled] = useState(
		props.antiPassback?.daysOfWeekActivated[4] || false
	);
	const [friday, setFridayEnabled] = useState(
		props.antiPassback?.daysOfWeekActivated[5] || false
	);
	const [saturdayEnabled, setSaturdayEnabled] = useState(
		props.antiPassback?.daysOfWeekActivated[6] || false
	);
	const [hasExitControl, setHasExitControl] = useState(props.antiPassback?.hasExitControl || false);
	const [hasAutoClean, setHasAutoClean] = useState(props.antiPassback?.hasAutoClean || false);
	const [hasExitDelay, setHasExitDelay] = useState(props.antiPassback?.hasExitDelay || false);
	const [exitDelay, setExitDelay] = useState(props.antiPassback?.exitDelay || 0);
	const [autoCleanTime, setAutoCleanTime] = useState(props.antiPassback?.autoCleanTime || 0);

	const { selectedCondominio, selectedLicenceId } = useUserStore();
	const [accessSelected, setAccessSelected] = useState(
		props.antiPassback?.accessModules
	);
	const [groupsSelected, setGroupsSelected] = useState(
		props.antiPassback?.groups
	);

	useEffect(() => {
		setName(props.antiPassback?.name);
		setEnabled(props.antiPassback?.enabled);
		setDescription(props.antiPassback?.description);
		setStartTime(props.antiPassback?.startTime);
		setEndTime(props.antiPassback?.endTime);
		setSundayEnabled(props.antiPassback?.daysOfWeekActivated[0] || false);
		setMondayEnabled(props.antiPassback?.daysOfWeekActivated[1] || false);
		setTuesdayEnabled(props.antiPassback?.daysOfWeekActivated[2] || false);
		setWednesdayEnabled(props.antiPassback?.daysOfWeekActivated[3] || false);
		setThursdayEnabled(props.antiPassback?.daysOfWeekActivated[4] || false);
		setFridayEnabled(props.antiPassback?.daysOfWeekActivated[5] || false);
		setSaturdayEnabled(props.antiPassback?.daysOfWeekActivated[6] || false);
		setHasExitControl(props.antiPassback?.hasExitControl || false);
		setHasAutoClean(props.antiPassback?.hasAutoClean || false);
		setHasExitDelay(props.antiPassback?.hasExitDelay || false);
		setExitDelay(props.antiPassback?.exitDelay || 0);
		setAutoCleanTime(props.antiPassback?.autoCleanTime || 0);
	}, [props.antiPassback]);

	const navigate = useNavigate();

	const buildPayload = () => {
		let payload = {
			id_condominium: parseInt(selectedCondominio),
			licence_id: selectedLicenceId,
			name,
			enabled,
			description,
			startTime,
			endTime,
			hasExitControl,
			hasAutoClean,
			autoCleanTime,
			hasExitDelay,
			exitDelay,
			daysOfWeekActivated: [
				sunday || false,
				mondayEnabled || false,
				tuesdayEnabled || false,
				wednesdayEnabled || false,
				thursdayEnabled || false,
				friday || false,
				saturdayEnabled || false,
			],
			antiPassbackAccessModules: accessSelected?.map(accessSelected => ({
				id: accessSelected.relationId ?? null,
				moduleId: accessSelected.originalId,
				accessIndex: accessSelected.subIndex,
			})) || [],
			groups: groupsSelected?.map(groupSelected => ({
				id: groupSelected.originalId,
			})) || [],
			uuid: uuidv4(),
		};
		return payload;
	};

	async function handleSubmit(event) {
		event.preventDefault();
		if (props.type === "edicao") {
			handleEdit(event);
			return;
		}
		const payload = buildPayload();
		const response = await AntiPassbackService.createAntiPassback(payload);
		if (response.data.id) navigate("../consulta-anti-passbacks", {
			state: { refresh: true }
		});
	}

	async function handleEdit(event) {
		event.preventDefault();
		const payload = buildPayload();
		const response = await AntiPassbackService.updateAntiPassback(
			props.antiPassback.id,
			payload
		);
		if (response.data.id) navigate("../consulta-anti-passbacks");
	}

	async function handleDelete() {
		if (!props.antiPassback) return;
		await AntiPassbackService.deleteAntiPassback(props.antiPassback.id);
		navigate("../consulta-anti-passbacks", {
			state: { deletedId: props.antiPassback.id },
		});
	}

	const handleClickEditButton = () => {
		if (!props.antiPassback) return;
		navigate(`/anti-passbacks/${props.antiPassback.uuid}`, { state: props.antiPassback });
	};

	const handleChangeDualList = (accessSelectedArray) => {
		setAccessSelected(accessSelectedArray);
	};

	const handleChangeGroupsDualList = (groupsSelectedArray) => {
		setGroupsSelected(groupsSelectedArray);
	};

	return (
		<>
			{!props.isTemp && (
				<FormTitle
					type={props.type}
					icon={<LuRouteOff size={20} />}
					tituloConsulta={props.antiPassback?.name || null}
					tituloCadastro="Cadastro de Anti Passback"
					backRoute={"/consulta-anti-passbacks"}
				/>
			)}
			<Form
				handleSubmit={handleSubmit}
				type={props.type}
				handleClickEdit={handleClickEditButton}
				handleDelete={handleDelete}
				navigateCancelUrl="../consulta-anti-passbacks"
				deleteButNotSynqed={props.antiPassback?.deletedAt ? true : false}
			>
				<div className="w-full grid grid-cols-1 gap-6">
					<div className="form-cond-container" style={{ width: '100%' }}>
						<div className={`grid ${props.type === "consulta" ? 'grid-cols-1' : 'grid-cols-2'} gap-2.5 mb-3.5!`}>
							<Input
								name="name"
								id="name"
								labelText="Nome *"
								value={name}
								onChange={({ target }) => { setName(target.value); }}
								disabled={props.type === "consulta"}
								required={true}
								tooltipText="Nome do anti passback"
								tooltipVisible={true}
							/>
							<Input
								name="Descricao"
								id="descricao"
								labelText="Descrição"
								value={description}
								onChange={({ target }) => { setDescription(target.value); }}
								hidden={props.type === "consulta"}
								disabled={props.type === "consulta"}
								required={false}
								tooltipText="Descrição do anti passback"
								tooltipVisible={true}
							/>
						</div>
						<div className={`grid ${props.type === "consulta" ? 'grid-cols-1' : 'grid-cols-2'} gap-2.5 mb-3.5!`}>
							<div className='flex flex-col items-start gap-3.5 my-2'>
								<ToggleButton
									style={{ width: 'fit-content' }}
									label={`Habilitado`}
									onChange={(e) => setEnabled(e.target.checked)}
									disabled={props.type === "consulta"}
									selected={enabled}
								/>
							</div>
							<div className='flex flex-col items-start gap-3.5 my-2'>
								<ToggleButton
									style={{ width: 'fit-content' }}
									label={`Controla Saída`}
									onChange={(e) => setHasExitControl(e.target.checked)}
									disabled={props.type === "consulta"}
									selected={hasExitControl}
								/>
							</div>
						</div>
						<div className={`grid ${props.type === "consulta" ? 'grid-cols-1' : 'grid-cols-2'} gap-2.5 mb-3.5!`}>
							<div className='flex flex-col items-start gap-3.5 my-2'>
								<ToggleButton
									style={{ width: 'fit-content' }}
									label={`Auto Limpar`}
									onChange={(e) => setHasAutoClean(e.target.checked)}
									disabled={props.type === "consulta"}
									selected={hasAutoClean}
								/>
								{hasAutoClean && (
									<Input
										name="autoCleanTime"
										id="autoCleanTime"
										type="number"
										labelText="Tempo de Auto Limpeza (s)"
										value={autoCleanTime}
										onChange={({ target }) => setAutoCleanTime(target.value)}
										disabled={props.type === "consulta"}
										required={true}
									/>
								)}
							</div>
							<div className='flex flex-col items-start gap-3.5 my-2'>
								<ToggleButton
									style={{ width: 'fit-content' }}
									label={`Atraso de Saída`}
									onChange={(e) => setHasExitDelay(e.target.checked)}
									disabled={props.type === "consulta"}
									selected={hasExitDelay}
								/>
								{hasExitDelay && (
									<Input
										name="exitDelay"
										id="exitDelay"
										type="number"
										labelText="Tempo de Atraso de Saída (s)"
										value={exitDelay}
										onChange={({ target }) => setExitDelay(target.value)}
										disabled={props.type === "consulta"}
										required={true}
									/>
								)}
							</div>
						</div>
						{props.type !== "consulta" && (
							<>
								<div className="grid grid-cols-2 gap-2.5">
									<div className="group-of-inputs-container week-container h-fit!">
										<p className="group-of-inputs-title">Selecione os dias para executar (ou desmarque todos para ignorar os dias)</p>
										<div className="checkbox-container">
											<Checkbox
												labelText="Domingo"
												defaultChecked={sunday}
												onChange={({ target }) => {
													setSundayEnabled(target.checked);
												}}
												required={false}
												inputWidth="200px"
												minWidthLabel="120px"
												disabled={props.type === "consulta"}
											></Checkbox>
											<Checkbox
												labelText="Segunda"
												defaultChecked={mondayEnabled}
												onChange={({ target }) => {
													setMondayEnabled(target.checked);
												}}
												required={false}
												inputWidth="200px"
												minWidthLabel="120px"
												disabled={props.type === "consulta"}
											></Checkbox>
											<Checkbox
												labelText="Terça"
												defaultChecked={tuesdayEnabled}
												onChange={({ target }) => {
													setTuesdayEnabled(target.checked);
												}}
												required={false}
												inputWidth="200px"
												minWidthLabel="120px"
												disabled={props.type === "consulta"}
											></Checkbox>
											<Checkbox
												labelText="Quarta"
												defaultChecked={wednesdayEnabled}
												onChange={({ target }) => {
													setWednesdayEnabled(target.checked);
												}}
												required={false}
												inputWidth="200px"
												minWidthLabel="120px"
												disabled={props.type === "consulta"}
											></Checkbox>
											<Checkbox
												labelText="Quinta"
												defaultChecked={thursdayEnabled}
												onChange={({ target }) => {
													setThursdayEnabled(target.checked);
												}}
												required={false}
												inputWidth="200px"
												minWidthLabel="120px"
												disabled={props.type === "consulta"}
											></Checkbox>
											<Checkbox
												labelText="Sexta"
												defaultChecked={friday}
												onChange={({ target }) => {
													setFridayEnabled(target.checked);
												}}
												required={false}
												inputWidth="200px"
												minWidthLabel="120px"
												disabled={props.type === "consulta"}
											></Checkbox>
											<Checkbox
												labelText="Sábado"
												defaultChecked={saturdayEnabled}
												onChange={({ target }) => {
													setSaturdayEnabled(target.checked);
												}}
												required={false}
												inputWidth="200px"
												minWidthLabel="120px"
												disabled={props.type === "consulta"}
											></Checkbox>
										</div>
									</div>
									<div className="date-time-container">
										<h3 className="box-title">Horário</h3>
										<div
											className={
												"date-time-grid" +
												(props.type === "consulta" ? " consulta-mode" : "")
											}
										>
											<Input
												name="start_hour"
												id="start_hour"
												type="time"
												min="00:00"
												max="23:59"
												labelText="Hora Início"
												value={startTime}
												onChange={({ target }) => { setStartTime(target.value); }}
												disabled={props.type === "consulta"}
												required={false}
												tooltipText="Hora de início"
												tooltipVisible={true}
											/>
											<Input
												name="end_hour"
												id="end_hour"
												type="time"
												min="00:00"
												max="23:59"
												labelText="Hora Fim"
												value={endTime}
												onChange={({ target }) => { setEndTime(target.value); }}
												disabled={props.type === "consulta"}
												required={false}
												tooltipText="Hora de fim"
												tooltipVisible={true}
											/>
										</div>
									</div>
								</div>
							</>
						)}
					</div>
					<div className="w-full grid grid-cols-2 gap-2.5">
						{props.type !== "consulta" && (
							<div className="container-dual-list-access-groups w-full!" style={{ display: "flex" }}>
								<div className="form-cond-dual-list-container">
									<AntiPassbackAccessModulesDDL
										onChangeList={handleChangeDualList}
										antiPassback={props.antiPassback}
									/>
								</div>
							</div>
						)}
						{props.type !== "consulta" && (
							<div className="container-dual-list-access-groups w-full!" style={{ display: "flex" }}>
								<div className="form-cond-dual-list-container">
									<AccessGroupsDDL
										onChangeList={(notSelected, selected) => handleChangeGroupsDualList(selected)}
										groups={props.antiPassback?.groups}
									/>
								</div>
							</div>
						)}
					</div>
				</div>
			</Form>
		</>
	);
}

export default FormAntiPassbacks;
